module.exports = __webpack_public_path__ + "static/media/lock_glyph2.3fa29734.svg";